'use client';
import { createContext, useContext } from 'react';

import type { MediaGalleryContextValue } from './types';

export const MediaGalleryContext = createContext<MediaGalleryContextValue>({
	openMediaPage: () => undefined,
	setGalleryData: () => undefined,
});

export const useMediaGalleryContext = () => {
	const context = useContext(MediaGalleryContext);
	if (!context) {
		throw Error('MediaGalleryContext no context Provider');
	}
	return context;
};
